import { Link } from 'react-router-dom';
import { categories } from '@/mocks/articles';

export default function Footer() {
  return (
    <footer className="bg-foreground-950 text-background-50">
      <div className="px-4 md:px-6 py-14">
        <div className="flex flex-col lg:flex-row gap-10 lg:gap-16">
          <div className="lg:w-[35%]">
            <Link to="/" className="inline-block cursor-pointer">
              <span className="font-heading text-3xl text-background-50">51吃瓜黑料网</span>
            </Link>
            <p className="mt-6 text-sm text-foreground-300 leading-relaxed max-w-md">
              51吃瓜黑料网是国内领先的娱乐八卦资讯平台，专注网曝门事件、网红猛料、每日大赛等热门内容。
              我们致力于为用户提供最新、最全、最真实的娱乐资讯，7×24小时不间断更新。
            </p>
            <div className="mt-6 flex items-center gap-3">
              {['ri-weibo-line', 'ri-wechat-line', 'ri-tiktok-line', 'ri-bilibili-line'].map((icon) => (
                <a
                  key={icon}
                  href="#"
                  className="w-10 h-10 flex items-center justify-center rounded-full border border-foreground-700 text-foreground-400 hover:text-primary-400 hover:border-primary-400 transition-colors duration-200 cursor-pointer"
                  aria-label="社交媒体"
                >
                  <i className={`${icon} text-lg`}></i>
                </a>
              ))}
            </div>
          </div>

          <div className="lg:w-[20%]">
            <h4 className="text-xs font-bold uppercase tracking-wider text-foreground-400 mb-5">热门分类</h4>
            <div className="flex flex-col gap-3">
              {categories.slice(0, 6).map((cat) => (
                <Link
                  key={cat.slug}
                  to={`/category/${cat.slug}`}
                  className="text-sm text-foreground-300 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap cursor-pointer"
                >
                  {cat.name}
                </Link>
              ))}
            </div>
          </div>

          <div className="lg:w-[25%]">
            <h4 className="text-xs font-bold uppercase tracking-wider text-foreground-400 mb-5">联系我们</h4>
            <div className="flex flex-col gap-4">
              <div>
                <p className="text-xs text-foreground-500 uppercase tracking-wider">地址</p>
                <p className="text-sm text-foreground-300 mt-1">北京市朝阳区互联网大街888号吃瓜大厦</p>
              </div>
              <div>
                <p className="text-xs text-foreground-500 uppercase tracking-wider">电话</p>
                <p className="text-sm text-foreground-300 mt-1">400-888-5151</p>
              </div>
              <div>
                <p className="text-xs text-foreground-500 uppercase tracking-wider">邮箱</p>
                <p className="text-sm text-foreground-300 mt-1">hello@moonr.cn</p>
              </div>
            </div>
          </div>

          <div className="lg:w-[20%]">
            <div className="w-full aspect-[3/4] rounded-lg overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Abstract%20modern%20editorial%20team%20illustration%20warm%20coral%20and%20amber%20tones%20stylized%20newsroom%20scene%20creative%20workspace%20atmosphere%20minimalist%20composition%20with%20warm%20lighting%20soft%20gradients%20contemporary%20art%20style&width=600&height=800&seq=footer-team-01&orientation=portrait"
                alt="51吃瓜黑料网团队"
                className="w-full h-full object-cover rounded-lg"
              />
            </div>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-foreground-800 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-500">
            &copy; 2026 51吃瓜黑料网 版权所有 | 京ICP备XXXXXXXX号
          </p>
          <div className="flex items-center gap-6">
            <Link to="/about" className="text-xs text-foreground-500 hover:text-foreground-300 transition-colors whitespace-nowrap cursor-pointer">关于我们</Link>
            <a href="#" className="text-xs text-foreground-500 hover:text-foreground-300 transition-colors whitespace-nowrap cursor-pointer">隐私政策</a>
            <a href="#" className="text-xs text-foreground-500 hover:text-foreground-300 transition-colors whitespace-nowrap cursor-pointer">用户协议</a>
          </div>
        </div>
      </div>
    </footer>
  );
}